import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=10437dcb&scoped=true"
import script from "./AdminAdd.vue?vue&type=script&lang=js"
export * from "./AdminAdd.vue?vue&type=script&lang=js"
import style0 from "./AdminAdd.vue?vue&type=style&index=0&id=10437dcb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10437dcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10437dcb')) {
      api.createRecord('10437dcb', component.options)
    } else {
      api.reload('10437dcb', component.options)
    }
    module.hot.accept("./AdminAdd.vue?vue&type=template&id=10437dcb&scoped=true", function () {
      api.rerender('10437dcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/components/AdminAdd.vue"
export default component.exports